import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userLoginAction, getMapId, getSiteName, getUserDetailsAction, } from "../../store/authSlice";
import { checkMapExistsAction } from "../../store/siteSlice";
import { LoadingContainer, LoadingSpinner, LoadingText } from "./auth.styles";
{ /* Types for better type safety */ }
{ /* Utility Functions */ }
const getAuthParamsFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const orgId = urlParams.get('orgId');
    return {
        sessionId: urlParams.get('sessionId') || undefined,
        organizationId: orgId || undefined,
        mapId: urlParams.get('mapId') || undefined,
        siteName: urlParams.get('siteName') || undefined,
    };
};
const storeAuthData = (data) => {
    if (data.mapId)
        localStorage.setItem('mapId', data.mapId);
    if (data.siteName)
        localStorage.setItem('siteName', data.siteName);
};
const Auth = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    { /*Authentication handler */ }
    const handleAuthentication = useCallback(async (authParams) => {
        try {
            if (!authParams.sessionId || !authParams.organizationId) {
                console.error('Missing required authentication parameters');
                return;
            }
            const loginData = {
                sessionId: authParams.sessionId,
                organizationId: parseInt(authParams.organizationId),
            };
            const response = await dispatch(userLoginAction(loginData));
            const loginResponse = response?.payload;
            if (!loginResponse?.data?.accessToken) {
                console.error('Authentication failed - invalid credentials');
                return;
            }
            { /* Get user details after successful login */ }
            await dispatch(getUserDetailsAction());
            { /* Handle site validation if mapId and siteName are provided */ }
            if (authParams.mapId && authParams.siteName) {
                await handleSiteValidation(authParams.mapId, authParams.siteName);
            }
            else {
                { /* No site info provided, redirect to default route */ }
                setTimeout(() => navigate('/dashboard'), 1000);
            }
        }
        catch (error) {
            console.error('Authentication error:', error);
        }
    }, [dispatch, navigate]);
    { /* Site validation handler */ }
    const handleSiteValidation = useCallback(async (mapId, siteName) => {
        try {
            const response = await dispatch(checkMapExistsAction(mapId));
            const siteResponse = response?.payload;
            { /* Store auth data */ }
            storeAuthData({ mapId, siteName });
            dispatch(getMapId(mapId));
            dispatch(getSiteName(siteName));
            { /* Determine navigation route based on site status */ }
            const navigationRoute = determineNavigationRoute(siteResponse);
            { /* Navigate to determined route */ }
            setTimeout(() => navigate(navigationRoute), 1000);
        }
        catch (error) {
            console.error('Site validation error:', error);
        }
    }, [dispatch, navigate]);
    { /* Utility function to determine navigation route */ }
    const determineNavigationRoute = (siteResponse) => {
        if (siteResponse?.status === 200) {
            const { draft, address } = siteResponse.data || {};
            if (draft && !address) {
                return "/create-site";
            }
            else if (draft && address) {
                return "/building";
            }
            else if (!draft) {
                return {
                    pathname: "/editor",
                    search: 'panel=mapping'
                };
            }
        }
        else if (siteResponse?.status === 404) {
            return "/create-site";
        }
        { /* Default fallback */ }
        return "/dashboard";
    };
    { /* Initialize authentication on component mount */ }
    useEffect(() => {
        const authParams = getAuthParamsFromUrl();
        if (Object.keys(authParams).length === 0) {
            console.error('No authentication parameters found');
            return;
        }
        handleAuthentication(authParams);
    }, [handleAuthentication]);
    { /* Loading UI with spinner */ }
    return (_jsxs(LoadingContainer, { children: [_jsx(LoadingSpinner, { size: "large" }), _jsx(LoadingText, { children: "Authenticating" })] }));
};
export default Auth;
